import React, { useEffect, useState } from "react";
import {
  BitcoinIcon,
  ChevronLeftIcon,
  EtheriumIcon,
  LitecoinIcon,
  SolanaIcon,
} from "../icons";
import QRCode from "react-qr-code";
import toast, { Toaster } from "react-hot-toast";

import { Card, CardBody } from "@windmill/react-ui";
import CopyToClipboard from 'react-copy-to-clipboard';
import useApi from "../hooks/useApi";
import { getCurrency } from "../utils/Api";
import { useDispatch, useSelector } from "../store";
import snackbar from "../store/reducers/snackbar";
import { ChangePage, changeChatOpen } from "../store/reducers/menu";
import { SetNowpayMinAmount } from "../store/reducers/auth";
import loading from "../utils/Loading";
import { useAccount } from 'wagmi'
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useWallet } from '@solana/wallet-adapter-react';
import { useWalletModal } from '@solana/wallet-adapter-react-ui';
import { SetSolDeposit } from "../store/reducers/auth";


export default function WalletConnect() {
  const { balances } = useSelector((store) => store.auth);
  const dispatch = useDispatch();
  const [currency, setCurrency] = useState({});
  const [address, setAddress] = useState("");
  const { createNowpayments, getPaymentCurrencyInfo } = useApi();
  const { isConnected } = useAccount();
  const history = useHistory();
  const { connected, publicKey, disconnect, signMessage: solanaSign } = useWallet();

  const handleGateWayDeposite = async () => {
    try {
      loading();
      getPaymentCurrencyInfo(currency).then(({ data }) => {
        loading(false)
        if (data.min_amount) {
          dispatch(SetNowpayMinAmount({ minAmount: data.min_amount }));
          dispatch(ChangePage('buycryptoGateway'))
        } else {
          toast.error(data.error);
        }
      }).catch();
    } catch (e) {
      console.log(e);
    }
  }

  const handleWalletDeposit = () => {
    if (!isConnected) {
      toast.error('Please connect metamask.');
      history.push('/app/profile/wallet')
      dispatch(ChangePage(""))
    } else {
      if (currency.symbol === "SOL") {
        dispatch(SetSolDeposit(true));
        history.push('/app/profile/wallet')
        dispatch(ChangePage(""))
      } else {
        dispatch(ChangePage('buycryptoMetamask'));
      }
    }
  }

  const setNowCurrency = () => {
    if (balances.length > 0) {
      balances.map((item) => {
        if (item.status) {
          setCurrency(item.currency);
        }
      });
    }
  }

  useEffect(() => {
    setNowCurrency();
  }, [balances]);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 py-4">
      <Card>
        <CardBody className="flex items-start flex-col space-y-4 text-white px-8">
          <h1 className="text-sm px-1 md:px-0 w-full text-gray-300 font-bold hover:text-gray-400 cursor-pointer float-left text-center">
            PAYMENT GATEWAY
          </h1>
          <div className="flex flex-col justify-between items-center w-full space-y-4">
            <img src="/demo/assets/gateway-icon.png" className="w-12 h-12" />
            <button className="btn-primary w-full transition ease-in-out hover:-translate-y-1 hover:scale-105 duration-300" onClick={() => handleGateWayDeposite()}>
              Deposit
            </button>
          </div>
        </CardBody>
      </Card>
      <Card>
        <CardBody className="flex items-start flex-col space-y-4 text-white px-8">
          <h1 className="text-sm px-1 w-full md:px-0 text-gray-300 font-bold hover:text-gray-400 cursor-pointer float-left text-center">
            WALLET CONNECT
          </h1>
          <div className="flex flex-col justify-between items-center w-full space-y-4">
            <img src="/demo/assets/metamask-icon.webp" className="w-12 h-12" />
            <button className="btn-primary w-full transition ease-in-out hover:-translate-y-1 hover:scale-105 duration-300" onClick={() => handleWalletDeposit()}>
              Deposit
            </button>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
